import styled from 'styled-components'
import { mq } from '../../styles/vars/media-queries.style'
import { Heading2 } from '../../styles/vars/textStyles.style'

export const TextWrapper = styled.div`
  ${Heading2} {
    ${mq.deskL} {
      padding-right: calc((100% / 3) * 0.75);
    }
  }
`

export const TextContent = styled.div`
  ${mq.tabletL} {
    align-content: center;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    height: 100%;
  }
`
